var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconXls(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-xls_svg__icon-xls_svg__Canvas",
    transform: "translate(16777 778)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-xls_svg__icon-xls_svg__Group_4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-xls_svg__icon-xls_svg__Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-xls_svg__icon-xls_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#icon-xls_svg__icon-xls_svg__path0_fill",
    transform: "translate(-16765.8 -774.952)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icon-xls_svg__icon-xls_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#icon-xls_svg__icon-xls_svg__path1_fill",
    transform: "translate(-16777 -778)"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "icon-xls_svg__icon-xls_svg__path0_fill",
    d: "M 3.75 0L 0 0L 0 10.6667L 3.75 10.6667L 3.75 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icon-xls_svg__icon-xls_svg__path1_fill",
    d: "M 0 13.3333L 10.5 16L 10.5 0L 0 2.66667L 0 13.3333ZM 2.625 4.44444L 4.29375 4.44444L 5.23125 6.41778L 6.20625 4.44444L 7.8375 4.44444L 6.13125 7.27111L 8.00625 10.5956L 6.3375 10.5956L 5.23125 8.24889L 4.14375 10.5956L 2.5125 10.5956L 4.33125 7.32444L 2.625 4.44444Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconXls);
export default __webpack_public_path__ + "static/media/icon-xls.34485165b47bc544888b3fff965bc885.svg";
export { ForwardRef as ReactComponent };